export default __webpack_public_path__ + "static/media/vodafone.7599a835.svg";